module.exports = __webpack_public_path__ + "static/media/view.b3e7f1f1.svg";